export default __webpack_public_path__ + "static/media/walletConnectIcon.69b7a669.svg";